import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import Config from "../../config";

import "./EmployeeOfferPublic.css";


const apiBase =
  String(
    Config.site_api ||
    ""
  ).replace(
    /\/$/,
    ""
  );


const call =
  async (
    url,
    options = {}
  ) => {

    const response =
      await fetch(
        url,
        {
          ...options,

          headers: {
            Accept:
              "application/json",

            ...(
              options.headers ||
              {}
            ),
          },
        }
      );


    let body = {};


    try {

      body =
        await response.json();

    } catch (
      error
    ) {

      body = {};

    }


    if (
      !response.ok ||
      body?.success ===
      false
    ) {

      throw new Error(
        body?.message ||
        "Request failed."
      );

    }


    return body?.data ??
      body;

  };


const EmployeeOfferPublic =
  ({
    match,
  }) => {

    const token =
      match?.params
        ?.token ||
      "";

    const [
      offer,
      setOffer,
    ] =
      useState(null);

    const [
      error,
      setError,
    ] =
      useState("");

    const [
      step,
      setStep,
    ] =
      useState("offer");

    const [
      form,
      setForm,
    ] =
      useState({
        declarationAccepted:
          false,
      });

    const [
      rejectOpen,
      setRejectOpen,
    ] =
      useState(false);

    const [
      rejectReason,
      setRejectReason,
    ] =
      useState("");

    const [
      busy,
      setBusy,
    ] =
      useState(false);


    const businessName =
      useMemo(
        () =>
          offer
            ?.businessSnapshot
            ?.legalName ||
          offer
            ?.businessSnapshot
            ?.name ||
          "Your Employer",
        [
          offer,
        ]
      );


    const load =
      async () => {

        try {

          setError(
            ""
          );


          const data =
            await call(
              `${apiBase}/v1/public/employee-offers/${encodeURIComponent(
                token
              )}`
            );


          setOffer(
            data
          );


          setForm(
            previous => ({
              ...previous,

              fullName:
                previous.fullName ||
                data?.personalDetails
                  ?.fullName ||
                data?.candidateSnapshot
                  ?.name ||
                "",

              mobile:
                previous.mobile ||
                data?.personalDetails
                  ?.mobile ||
                data?.candidateSnapshot
                  ?.mobile ||
                "",

              email:
                previous.email ||
                data?.personalDetails
                  ?.email ||
                data?.candidateSnapshot
                  ?.email ||
                "",
            })
          );


          if (
            [
              "ACCEPTED",
              "DETAILS_SUBMITTED",
              "VERIFIED",
              "CREDENTIALS_SENT",
            ].includes(
              data?.status
            )
          ) {

            setStep(
              data.status ===
              "ACCEPTED"
                ?
                "details"
                :
                "done"
            );

          }

        } catch (
          loadError
        ) {

          setError(
            loadError?.message ||
            "Invalid offer link."
          );

        }

      };


    useEffect(
      () => {

        if (
          token
        ) {
          load();
        }

      // eslint-disable-next-line react-hooks/exhaustive-deps
      },
      [
        token,
      ]
    );


    const acceptOffer =
      async () => {

        setBusy(
          true
        );

        setError(
          ""
        );


        try {

          await call(
            `${apiBase}/v1/public/employee-offers/${encodeURIComponent(
              token
            )}/accept`,
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body:
                "{}",
            }
          );


          await load();

          setStep(
            "details"
          );

        } catch (
          acceptError
        ) {

          setError(
            acceptError?.message ||
            "Unable to accept offer."
          );

        } finally {

          setBusy(
            false
          );

        }

      };


    const rejectOffer =
      async () => {

        setBusy(
          true
        );

        setError(
          ""
        );


        try {

          await call(
            `${apiBase}/v1/public/employee-offers/${encodeURIComponent(
              token
            )}/reject`,
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body:
                JSON.stringify({
                  reason:
                    rejectReason,
                }),
            }
          );


          setRejectOpen(
            false
          );

          await load();

          setStep(
            "done"
          );

        } catch (
          rejectError
        ) {

          setError(
            rejectError?.message ||
            "Unable to reject offer."
          );

        } finally {

          setBusy(
            false
          );

        }

      };


    const submit =
      async event => {

        event.preventDefault();


        if (
          !form
            .declarationAccepted
        ) {

          setError(
            "Please accept the declaration before submitting."
          );

          return;
        }


        setBusy(
          true
        );

        setError(
          ""
        );


        try {

          const fd =
            new FormData();


          Object.entries(
            form
          )
            .forEach(
              (
                [
                  key,
                  value
                ]
              ) => {

                if (
                  value ==
                    null ||
                  key ===
                    "declarationAccepted"
                ) {
                  return;
                }


                if (
                  Array.isArray(
                    value
                  )
                ) {

                  value.forEach(
                    file =>
                      fd.append(
                        key,
                        file
                      )
                  );

                } else {

                  fd.append(
                    key,
                    value
                  );

                }

              }
            );


          await call(
            `${apiBase}/v1/public/employee-offers/${encodeURIComponent(
              token
            )}/details`,
            {
              method:
                "POST",

              body:
                fd,
            }
          );


          await load();

          setStep(
            "done"
          );

        } catch (
          submitError
        ) {

          setError(
            submitError?.message ||
            "Unable to submit onboarding details."
          );

        } finally {

          setBusy(
            false
          );

        }

      };


    if (
      error &&
      !offer
    ) {

      return (
        <div className="public-offer-shell">
          <div className="public-offer-card public-offer-state">
            <h2>
              Offer Letter
            </h2>
            <p className="error">
              {error}
            </p>
          </div>
        </div>
      );

    }


    if (
      !offer
    ) {

      return (
        <div className="public-offer-shell">
          <div className="public-offer-loading">
            Loading secure offer...
          </div>
        </div>
      );

    }


    return (

      <div className="public-offer-shell">

        <div className="public-offer-card">

          <header className="public-offer-header">

            <div className="public-offer-business">

              {
                offer.businessSnapshot
                  ?.logo
                  ?
                  (
                    <img
                      src={
                        offer.businessSnapshot
                          .logo
                      }
                      alt={
                        businessName
                      }
                    />
                  )
                  :
                  (
                    <div className="public-offer-business-mark">
                      {
                        businessName
                          .split(
                            /\s+/
                          )
                          .filter(
                            Boolean
                          )
                          .slice(
                            0,
                            2
                          )
                          .map(
                            word =>
                              word[0]
                          )
                          .join(
                            ""
                          )
                          .toUpperCase()
                      }
                    </div>
                  )
              }


              <div>

                <h1>
                  {businessName}
                </h1>

                <small>
                  Employment Offer
                </small>

                {
                  offer.businessSnapshot
                    ?.email
                    ?
                    (
                      <span>
                        {
                          offer.businessSnapshot
                            .email
                        }
                      </span>
                    )
                    :
                    null
                }

              </div>

            </div>


            <span className="public-offer-number">
              {offer.offerNumber}
            </span>

          </header>


          {
            error
              ?
              (
                <div className="public-offer-inline-error">
                  {error}
                </div>
              )
              :
              null
          }


          {
            step ===
            "offer"
              ?
              (
                <>

                  <p>
                    Dear <b>{offer.candidateSnapshot?.name}</b>,
                  </p>

                  <p>
                    We are pleased to offer you the position of <b>{offer.candidateSnapshot?.designation}</b>
                    {
                      offer.candidateSnapshot
                        ?.department
                        ?
                        ` in ${offer.candidateSnapshot.department}`
                        :
                        ""
                    } at <b>{businessName}</b>.
                  </p>


                  <div className="offer-grid">

                    <div>
                      Joining Date
                      <b>
                        {
                          offer.candidateSnapshot
                            ?.joiningDate
                            ?
                            new Date(
                              offer.candidateSnapshot
                                .joiningDate
                            )
                              .toLocaleDateString(
                                "en-IN"
                              )
                            :
                            "-"
                        }
                      </b>
                    </div>

                    <div>
                      Monthly Salary / Stipend
                      <b>
                        ₹{
                          Number(
                            offer.terms
                              ?.salaryMonthly ||
                            0
                          )
                            .toLocaleString(
                              "en-IN"
                            )
                        }
                      </b>
                    </div>

                    <div>
                      Probation
                      <b>
                        {offer.terms?.probationMonths || 0} months
                      </b>
                    </div>

                    <div>
                      Notice Period
                      <b>
                        {offer.terms?.noticePeriodDays || 30} days
                      </b>
                    </div>

                    <div>
                      Salary Payment
                      <b>
                        {
                          offer.terms
                            ?.salaryPaymentWindow ||
                          "Between the 5th and 10th of each month"
                        }
                      </b>
                    </div>

                    <div>
                      Work Location
                      <b>
                        {
                          offer.terms
                            ?.workLocation ||
                          "As assigned"
                        }
                      </b>
                    </div>

                  </div>


                  <h3>
                    Key Terms & Responsibilities
                  </h3>


                  <ul>
                    <li>
                      Maintain confidentiality of company, customer, commercial and technical information.
                    </li>
                    <li>
                      Follow company policies, attendance requirements, lawful instructions and professional conduct standards.
                    </li>
                    <li>
                      Employment is subject to verification of information and documents submitted during onboarding.
                    </li>

                    {
                      (
                        offer.terms
                          ?.responsibilities ||
                        []
                      )
                        .map(
                          (
                            item,
                            index
                          ) => (
                            <li key={index}>
                              {item}
                            </li>
                          )
                        )
                    }
                  </ul>


                  {
                    offer.terms
                      ?.additionalTerms
                      ?
                      (
                        <div className="public-offer-additional-terms">
                          <strong>
                            Additional Terms
                          </strong>
                          <p>
                            {
                              offer.terms
                                .additionalTerms
                            }
                          </p>
                        </div>
                      )
                      :
                      null
                  }


                  <div className="offer-actions">

                    <button
                      className="reject"
                      type="button"
                      disabled={
                        busy
                      }
                      onClick={
                        () =>
                          setRejectOpen(
                            true
                          )
                      }
                    >
                      Reject Offer
                    </button>


                    <button
                      className="accept"
                      type="button"
                      disabled={
                        busy
                      }
                      onClick={
                        acceptOffer
                      }
                    >
                      {
                        busy
                          ?
                          "Processing..."
                          :
                          "Accept Offer"
                      }
                    </button>

                  </div>

                </>
              )
              :
              null
          }


          {
            step ===
            "details"
              ?
              (
                <form onSubmit={submit}>

                  <div className="public-onboarding-title">

                    <span>
                      {businessName}
                    </span>

                    <h2>
                      Complete Your Onboarding
                    </h2>

                    <p className="helper">
                      Please provide accurate personal, KYC, bank and emergency-contact details for employment verification.
                    </p>

                  </div>


                  <div className="form-grid">

                    {
                      [
                        ["fullName", "Full Name"],
                        ["fatherName", "Father / Guardian Name"],
                        ["dateOfBirth", "Date of Birth", "date"],
                        ["gender", "Gender"],
                        ["mobile", "Mobile"],
                        ["alternateMobile", "Alternate Mobile"],
                        ["email", "Email", "email"],
                        ["panNumber", "PAN Number"],
                        ["aadhaarNumber", "Aadhaar Number"],
                        ["addressLine", "Address Line 1"],
                        ["addressLine2", "Address Line 2"],
                        ["city", "City"],
                        ["state", "State"],
                        ["pincode", "Pincode"],
                        ["emergencyName", "Emergency Contact Name"],
                        ["emergencyRelation", "Relation"],
                        ["emergencyMobile", "Emergency Mobile"],
                        ["bankName", "Bank Name"],
                        ["accountHolderName", "Account Holder Name"],
                        ["accountNumber", "Account Number"],
                        ["ifsc", "IFSC"],
                      ].map(
                        (
                          [
                            key,
                            label,
                            type
                          ]
                        ) => (
                          <label key={key}>
                            {label}
                            <input
                              type={
                                type ||
                                "text"
                              }
                              value={
                                typeof form[key] ===
                                "string"
                                  ?
                                  form[key]
                                  :
                                  ""
                              }
                              onChange={
                                event =>
                                  setForm({
                                    ...form,
                                    [key]:
                                      event.target.value,
                                  })
                              }
                            />
                          </label>
                        )
                      )
                    }

                  </div>


                  <h3>
                    Documents
                  </h3>


                  <div className="form-grid document-upload-grid">

                    {
                      [
                        ["aadhaarFront", "Aadhaar Front"],
                        ["aadhaarBack", "Aadhaar Back"],
                        ["panCard", "PAN Card"],
                        ["photo", "Photo"],
                        ["addressProof", "Address Proof"],
                        ["bankProof", "Bank Proof"],
                        ["education", "Education Documents"],
                      ].map(
                        (
                          [
                            key,
                            label
                          ]
                        ) => (
                          <label key={key}>
                            {label}
                            <input
                              type="file"
                              accept=".png,.jpg,.jpeg,.webp,.pdf"
                              multiple={
                                key ===
                                "education"
                              }
                              onChange={
                                event =>
                                  setForm({
                                    ...form,
                                    [key]:
                                      key ===
                                      "education"
                                        ?
                                        Array.from(
                                          event.target.files
                                        )
                                        :
                                        event.target.files[0],
                                  })
                              }
                            />
                          </label>
                        )
                      )
                    }

                  </div>


                  <label className="declaration">

                    <input
                      type="checkbox"
                      checked={
                        Boolean(
                          form.declarationAccepted
                        )
                      }
                      onChange={
                        event =>
                          setForm({
                            ...form,
                            declarationAccepted:
                              event.target.checked,
                          })
                      }
                    />

                    <span>
                      I confirm that the information and documents submitted are accurate and may be verified by {businessName} for employment and statutory record purposes.
                    </span>

                  </label>


                  <button
                    className="accept full"
                    type="submit"
                    disabled={
                      busy
                    }
                  >
                    {
                      busy
                        ?
                        "Submitting..."
                        :
                        "Submit for Verification"
                    }
                  </button>

                </form>
              )
              :
              null
          }


          {
            step ===
            "done"
              ?
              (
                <div className="done">

                  <h2>
                    Thank you
                  </h2>

                  <p>
                    {
                      offer.status ===
                      "REJECTED"
                        ?
                        `Your response has been recorded and shared with ${businessName}.`
                        :
                        offer.status ===
                        "CREDENTIALS_SENT"
                          ?
                          `Your onboarding is complete. ${businessName} has sent your panel credentials to your registered email.`
                          :
                          offer.status ===
                          "VERIFIED"
                            ?
                            `Your details have been verified by ${businessName}. Your panel credentials will be shared separately.`
                            :
                            `Your onboarding information has been submitted to ${businessName} for review.`
                    }
                  </p>

                </div>
              )
              :
              null
          }

        </div>


        {
          rejectOpen
            ?
            (
              <div className="public-reject-backdrop">

                <div className="public-reject-modal">

                  <h3>
                    Reject Employment Offer
                  </h3>

                  <p>
                    You are about to reject the offer from <strong>{businessName}</strong>.
                  </p>

                  <label>
                    Reason (optional)
                    <textarea
                      rows="4"
                      value={
                        rejectReason
                      }
                      onChange={
                        event =>
                          setRejectReason(
                            event.target.value
                          )
                      }
                      placeholder="You may share a short reason..."
                    />
                  </label>

                  <div>

                    <button
                      type="button"
                      onClick={
                        () =>
                          setRejectOpen(
                            false
                          )
                      }
                    >
                      Keep Offer
                    </button>

                    <button
                      type="button"
                      className="reject"
                      disabled={
                        busy
                      }
                      onClick={
                        rejectOffer
                      }
                    >
                      {
                        busy
                          ?
                          "Submitting..."
                          :
                          "Reject Offer"
                      }
                    </button>

                  </div>

                </div>

              </div>
            )
            :
            null
        }

      </div>

    );

  };


export default EmployeeOfferPublic;
